export default __webpack_public_path__ + "static/media/Cloudxier-HANDSON-Profile-Developer.7612bb9f.png";